var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, eventToSlice, eventDateRange } from '@shapeable/utils';
import { SliceBlockImage } from './slice-block-image';
import { useEntity } from '../hooks/use-entity';
var cls = classNames('slice-event-list');
export var SliceEventListDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var EventSliceStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: ", " 0 ", ";\n    font-size: 1.25em;\n\n    h2 {\n      line-height: 1.25em;\n      color: ", ";\n      font-size: 1.1em;\n      margin-bottom: ", ";\n    }\n  "], ["\n    margin: ", " 0 ", ";\n    font-size: 1.25em;\n\n    h2 {\n      line-height: 1.25em;\n      color: ", ";\n      font-size: 1.1em;\n      margin-bottom: ", ";\n    }\n  "])), theme.UNIT(14), theme.UNIT(16), theme.COLOR('strong'), theme.UNIT(2)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: ", " 0 ", ";\n  "], ["\n    margin: ", " 0 ", ";\n  "])), theme.UNIT(16), theme.UNIT(18))
});
var DateStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 300;\n    font-size: ", "em;\n    margin: ", " 0 ", ";\n  "], ["\n    color: ", ";\n    font-weight: 300;\n    font-size: ", "em;\n    margin: ", " 0 ", ";\n  "])), theme.COLOR('sub'), 20 / 16, theme.UNIT(1), theme.UNIT(5))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  EventSlice: styled(SliceBlockImage)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), EventSliceStyles),
  Date: styled.h4(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DateStyles)
};
export var SliceEventList = function (props) {
  var className = props.className,
    children = props.children,
    events = props.events;
  var entity = useEntity(props.entity);
  if (!(events === null || events === void 0 ? void 0 : events.length)) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, events.map(function (event, index) {
    var dates = eventDateRange(event.startDate, event.endDate);
    return React.createElement(My.EventSlice, {
      contentEntityBlockProps: {
        titleHref: event.path,
        afterSubtitle: React.createElement(My.Date, null, dates),
        afterContent: React.createElement("br", null)
      },
      reverse: index % 2 !== 0,
      key: event.slug,
      imageHref: event.path,
      entity: eventToSlice(event)
    });
  }), children);
};
SliceEventList.defaultProps = SliceEventListDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;